/**
 * vuex action
 *
 */

import {deepMerge} from "@/common/js/utils";
import * as types from "./mutation-types";

// 获取tokenName的值
export const getTokenName = ({commit, state}, tokenName)=>{
  commit(types.SET_TOKEN_NAME,tokenName);
}
// 获取token的值
export const getToken = ({commit, state}, token)=>{
  commit(types.SET_TOKEN,token);
}
// 获取lang的值
export const getLang = ({commit, state}, lang)=>{
  commit(types.SET_LANG,lang);
}
// 获取userInfo的值
export const getUserInfo = ({commit, state}, userInfo)=>{
  // userInfo = JSON.stringify(userInfo);
  commit(types.SET_USER_INFO, userInfo);
}
// 获取用户ID的值
export const getUserId = ({commit, state}, id)=>{
  commit(types.SET_USER_ID, id);
}
// 获取用户tag的值
export const getUserTags = ({commit, state}, tags)=>{
  commit(types.SET_USER_TAGS, tags);
}
// 获取未读消息数目
export const getIMMsgUnreadCount = ({commit, state}, unreadCount)=>{
  commit(types.SET_UNREAD_COUNT, unreadCount);
}
// 获取系统消息未读数目
export const getIMSystemMsgUnreadCount = ({commit, state}, unreadSystemCount=0)=>{
  commit(types.SET_SYSTEM_UNREAD_COUNT, unreadSystemCount);
}

// 获取客服消息未读数目
export const getIMCustomerMsgUnreadCount = ({commit, state}, unreadCustomerCount)=>{
  commit(types.SET_CUSTOMER_UNREAD_COUNT, unreadCustomerCount);
}
// 获取群组客服消息未读数目
export const getIMGroupsMsgTotalUnreadCount = ({commit, state}, unreadCustomerCount)=>{
  commit(types.SET_GROUPS_UNREAD_TOTAL_COUNT, unreadCustomerCount);
}

// 获取collapse折叠的布尔值
export const getCollapse = ({commit, state}, collapse)=>{
  commit(types.SET_COLLAPSE, collapse);
}
// 增加editableTabs数组的值
export const addEditableTabs = ({commit, state},tab)=>{
  let editableTabs = deepMerge([],state.editableTabs);
  tab = JSON.stringify(tab);

  if(editableTabs.indexOf(tab) === -1){
    editableTabs.push(tab);
    commit(types.SET_EDITABLE_TABS,editableTabs);
  }
}
// 删除editableTabs数组的值
export const deleteEditableTabs = ({commit, state},tab)=>{
  let editableTabs = deepMerge([],state.editableTabs);
  tab = JSON.stringify(tab);
  if(editableTabs.indexOf(tab) !== -1){
    let index = editableTabs.indexOf(tab);
    editableTabs.splice(index,1);
    commit(types.SET_EDITABLE_TABS,editableTabs);
  }
}

// 设置当前选中的tab项的值
export const getEditabletabsValue = ({commit, state},tabvalue)=>{
  commit(types.SET_EDITABLE_TABS_VALUE,tabvalue);
}

// 获取当前菜单数组的值
export const getMenulists = ({commit, state},menulists)=>{
  commit(types.SET_MENULISTS,menulists);
}
